/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRoomSleep = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M19 4H6v18H4V2h15v2zm-6 16h-2v-2h2v2zm8.707-8.793L19.914 13l1.793 1.793-1.414 1.414L17.086 13l3.207-3.207 1.414 1.414z"
        fill="currentcolor"
      />
      <path d="M13 16h-2V8h2v8z" fill="currentcolor" />
    </g>
  </Icon>
);
export { SvgRoomSleep as RoomSleep };
